import { createClient } from 'graphql-ws'

export const wsClient = createClient({
  url: process.env.VUE_APP_ASYNC_JOBS_WS || 'wss://async-jobs-subscription.mercafacil.com/graphql',
  lazy: true,
})

export const wsClientHulk = createClient({
  url: process.env.VUE_APP_GRAPHQL_WS || 'wss://hulk-subscription.mercafacil.com/graphql',
  lazy: true,
})
